import React from 'react';
import Header from '../Header';

// Pre-game waiting screen with team display and general chat
const WaitingRoom = ({
  game,
  currentUser,
  generalMessages = [],
  generalMessageInput,
  setGeneralMessageInput,
  handleSendGeneralMessage,
  sending,
  generalChatRef,
  onBackToDashboard,
}) => {
  return (
    <div className="game-container">
      <Header />

      <div className="game-content">
        <div className="waiting-room-layout">
          {/* Left: teams info */}
          <div className="waiting-screen">
            <div className="chess-icon-large">
              <svg viewBox="0 0 45 45" className="king-icon">
                <g fill="none" fillRule="evenodd" stroke="#6B8FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M 22.5,11.63 L 22.5,6" strokeLinejoin="miter"/>
                  <path d="M 20,8 L 25,8" strokeLinejoin="miter"/>
                  <path d="M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25"/>
                  <path d="M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37"/>
                  <path d="M 12.5,30 C 18,27 27,27 32.5,30" fill="none"/>
                  <path d="M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5" fill="none"/>
                  <path d="M 12.5,37 C 18,34 27,34 32.5,37" fill="none"/>
                </g>
              </svg>
            </div>
            <h2>Waiting for Game to Start</h2>
            <p className="waiting-message">The admin will start the game when all players are ready.</p>

            <div className="teams-waiting">
              <div className="team-waiting">
                <h3>♔ White Team ({game.whiteTeam?.length || 0})</h3>
                <div className="players-list">
                  {game.whiteTeam && game.whiteTeam.length > 0 ? (
                    game.whiteTeam.map((player, index) => (
                      <div key={index} className="player-waiting">
                        {player.nickname}
                      </div>
                    ))
                  ) : (
                    <span className="no-players-text">No players yet</span>
                  )}
                </div>
              </div>

              <div className="team-waiting">
                <h3>♚ Black Team ({game.blackTeam?.length || 0})</h3>
                <div className="players-list">
                  {game.blackTeam && game.blackTeam.length > 0 ? (
                    game.blackTeam.map((player, index) => (
                      <div key={index} className="player-waiting">
                        {player.nickname}
                      </div>
                    ))
                  ) : (
                    <span className="no-players-text">No players yet</span>
                  )}
                </div>
              </div>
            </div>

            <button onClick={onBackToDashboard} className="back-button">
              Back to Dashboard
            </button>
          </div>

          {/* Right: general chat */}
          <div className="waiting-general-chat">
            <div className="chat-header">
              <span className="chat-icon">💬</span>
              <h3>General Chat</h3>
            </div>
            <div className="chat-messages" ref={generalChatRef}>
              {generalMessages && generalMessages.length > 0 ? (
                generalMessages.map((msg, index) => (
                  <div
                    key={msg.id || index}
                    className={`chat-message ${msg.email === currentUser.email ? 'own-message' : ''} ${msg.isAdmin ? 'admin-message' : ''}`}
                  >
                    <div className="message-sender">
                      {msg.sender}
                      {msg.senderTeam && msg.senderTeam !== 'admin' && (
                        <span className={`waiting-team-badge ${msg.senderTeam}`}>
                          {msg.senderTeam === 'white' ? '♔' : '♚'}
                        </span>
                      )}
                    </div>
                    <div className="message-text">{msg.message}</div>
                    <div className="message-time">
                      {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </div>
                  </div>
                ))
              ) : (
                <p className="chat-placeholder">No messages yet. Say hello!</p>
              )}
            </div>
            <div className="chat-input-container">
              <input
                type="text"
                value={generalMessageInput}
                onChange={(e) => setGeneralMessageInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleSendGeneralMessage();
                  }
                }}
                placeholder="Chat with everyone..."
                disabled={sending}
                className="chat-input"
              />
              <button
                onClick={handleSendGeneralMessage}
                disabled={sending || !generalMessageInput.trim()}
                className="chat-send-button"
              >
                {sending ? '...' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitingRoom;
